import { render, staticRenderFns } from "./PosDetailsView.vue?vue&type=template&id=39579e3e"
import script from "./PosDetailsView.vue?vue&type=script&lang=js"
export * from "./PosDetailsView.vue?vue&type=script&lang=js"
import style0 from "./PosDetailsView.vue?vue&type=style&index=0&id=39579e3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports